<template>
  <div class="system-crashed">系统崩溃啦</div>
</template>

<script>
export default {
  name: 'SystemCrashed'
}
</script>

<style scoped>
.system-crashed {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #222;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 1px;
}
</style>
